import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Vue, Component, Inject, Prop } from 'vue-property-decorator';
import '../assets/css/form.scss';
let FormMixin = class FormMixin extends Vue {
  get rootVm() {
    const _rootVM = this.amRootVm || this.caller || {};
    if (!_rootVM.global) _rootVM.global = {};
    return _rootVM;
  }
  get activeItem() {
    return this.$store.getters.activeItem;
  }
  get width() {
    return this.label ? this.labelWidth || 'auto' : '0px';
  }
  //组件布局
  get displayClass() {
    let classes = [`layout-${this.position}`, this.position == 'top' ? 'left' : this.labelAlign];
    this.hidden && classes.push('is-hidden');
    this.readonly && classes.push('is-readonly');
    return classes;
  }
  get readonly() {
    return this.behavior == 'readonly';
  }
  get disabled() {
    return this.behavior == 'disabled';
  }
  get hidden() {
    return this.behavior == 'hidden';
  }
  change(val) {
    this.$emit('change', val);
  }
  get rules() {
    let rules = [];
    const funObjs = {
      required: item => {
        rules.push({
          required: true,
          message: item.message,
          trigger: ['blur', 'change']
        });
      },
      pattern: item => {
        rules.push({
          required: true,
          pattern: eval(item.value),
          message: item.message,
          trigger: item.trigger
        });
      },
      validator: item => {
        rules.push({
          validator: new Function('return ' + item.value).call(this.rootVm),
          trigger: item.trigger
        });
      }
    };
    this.validation.forEach(v => {
      var _funObjs$v$type;
      // isApply 在画布中时必然存在
      // 在预览和产物中时会被移除
      // 因此这里需要判断 === false
      if (v.isApply === false) return;
      (_funObjs$v$type = funObjs[v.type]) === null || _funObjs$v$type === void 0 || _funObjs$v$type.call(funObjs, v);
    });
    return rules;
  }
};
__decorate([Prop(String)], FormMixin.prototype, "prop", void 0);
__decorate([Prop(String)], FormMixin.prototype, "label", void 0);
__decorate([Prop({
  default: 'left',
  type: String
})], FormMixin.prototype, "position", void 0);
__decorate([Prop({
  default: 'left'
})], FormMixin.prototype, "labelAlign", void 0);
__decorate([Prop({
  default: '100px'
})], FormMixin.prototype, "labelWidth", void 0);
__decorate([Prop(String)], FormMixin.prototype, "tips", void 0);
__decorate([Prop({
  default: 'medium'
})], FormMixin.prototype, "size", void 0);
__decorate([Prop({
  default: 'normal'
})], FormMixin.prototype, "behavior", void 0);
__decorate([Prop({
  default: () => []
})], FormMixin.prototype, "validation", void 0);
__decorate([Prop(String)], FormMixin.prototype, "labelTooltip", void 0);
__decorate([Prop({
  default: 100
})], FormMixin.prototype, "labelTooltipWidth", void 0);
__decorate([Prop({
  default: 'dark'
})], FormMixin.prototype, "tooltipEffect", void 0);
__decorate([Prop({
  default: true
})], FormMixin.prototype, "showMessage", void 0);
__decorate([Prop({
  default: false
})], FormMixin.prototype, "inlineMessage", void 0);
__decorate([Prop()], FormMixin.prototype, "value", void 0);
__decorate([Prop({
  type: Object,
  default: () => {}
})], FormMixin.prototype, "caller", void 0);
__decorate([Inject('amRootVm')], FormMixin.prototype, "amRootVm", void 0);
FormMixin = __decorate([Component({
  name: 'FormMixin'
})], FormMixin);
export default FormMixin;